import parsePhoneNumber from 'libphonenumber-js';

const validatePhoneNumber = (phone?: string) => {
    if (!phone) return false;
    const phoneNumber = parsePhoneNumber(phone, 'US');
    return phoneNumber?.isValid();
};

export default validatePhoneNumber;
